import { apolloClient } from "@/plugins/apollo";
import gql from "fraql";
export async function checkUserCanAccessPersonDashboard(personId) {
    return await apolloClient
        .query({
        query: gql `
        query personCheckUserCanAccessIt($id: ID) {
          person(id: $id) {
            id
            reports(placement: "PERSON_DASHBOARD") {
              id
            }
          }
        }
      `,
        variables: { id: personId },
        fetchPolicy: "cache-first"
    })
        .then(({ data }) => {
        var _a, _b;
        return ((_b = (_a = data.person) === null || _a === void 0 ? void 0 : _a.reports) === null || _b === void 0 ? void 0 : _b.length) > 0;
    });
}
